class SmoothScroll {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    $(function(){
      const navBtn = $('.nav-btn').hasClass('is-active');
      const navBtnTxt = $('.nav-btn-txt').hasClass('is-active');
      const HeaderReserve = $('.header-reserve').hasClass('is-active');
      const navMenu = $('.navMenu').hasClass('is-active');
      const Header = $('.js-header').hasClass('is-active');
      const overLay = $('.bg-overlay').hasClass('is-active');
      const body = document.querySelector('body')

      var urlHash = location.hash;
      
      if(urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
          var target = $(urlHash);
          var position = target.offset().top - 80;
          $('body,html').stop().animate({scrollTop:position}, 1000);
        }, 100);
      }
      
      $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href);
        var position = target.offset().top - 80;

        if(!navBtn){
          $('.nav-btn').removeClass('is-active');
          $('.bg-overlay').removeClass('is-active');
          $('.nav-btn-txt').removeClass('is-active');
          $('.header-reserve').removeClass('is-active');
          $('.navMenu').removeClass('is-active');
          $('.js-header').removeClass('is-active');
          $('body').removeClass('no-scroll');
        }

        $('body,html').stop().animate({scrollTop:position}, 1000);
        return false;
      });
    });
  }
}
